import { render, staticRenderFns } from "./CardTarjaEnqueteTaOnQRCODE.vue?vue&type=template&id=8b772250&scoped=true"
import script from "./CardTarjaEnqueteTaOnQRCODE.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteTaOnQRCODE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteTaOnQRCODE.vue?vue&type=style&index=0&id=8b772250&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b772250",
  null
  
)

export default component.exports